import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { SystemStyleObject } from '@mui/system';
import React from 'react';

import InfoIcon from '@/assets/icons/info-icon.svg?react';
import { useTranslator } from '@/hooks/useTranslator';
import { ExpectedSettlementTimeDetails } from '@/types/transaction';

interface ExpectedSettlementTimeInfoProps {
  readonly expectedSettlementTimeDetails: ExpectedSettlementTimeDetails | null;
  readonly label?: string | React.ReactElement;
  readonly settlementTimeTextStyles?: SystemStyleObject;
}

export const ExpectedSettlementTimeInfo: React.FC<ExpectedSettlementTimeInfoProps> = (
  props: ExpectedSettlementTimeInfoProps,
): React.ReactElement | null => {
  const { expectedSettlementTimeDetails, label, settlementTimeTextStyles } = props;
  const tr = useTranslator();

  if (!expectedSettlementTimeDetails) {
    return null;
  }

  const { expectedTime, additionalInfo } = expectedSettlementTimeDetails;

  const settlementTimeText = tr(`SETTLEMENT_${expectedTime}`);

  return (
    <Stack sx={styles.root}>
      {label || <Typography>{tr('SETTLEMENT_TIME')}:</Typography>}
      <Stack sx={{ ...styles.text, ...settlementTimeTextStyles }}>
        <Typography>{settlementTimeText}</Typography>
        {additionalInfo && (
          <Tooltip placement="top" title={<Typography>{additionalInfo}</Typography>}>
            <Box sx={styles.icon}>
              <InfoIcon fill="currentColor" />
            </Box>
          </Tooltip>
        )}
      </Stack>
    </Stack>
  );
};

const styles: Record<string, SystemStyleObject> = {
  root: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 0.5,
  },
  text: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 0.5,
  },
  icon: {
    width: 18,
    height: 18,
    textAlign: 'center',
    '& svg': {
      width: '100%',
      height: '100%',
    },
  },
};
